import { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Collapse,
  Drawer,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Spin,
  Switch,
  message,
  notification,
} from "antd";
import { callCreateRole } from "../../../../config/api";
import classNames from "classnames/bind";
import styles from "./addRole.module.scss";
import { Checkbox } from "antd";
import type { CheckboxValueType } from "antd/es/checkbox/Group";
import { fetchPermission } from "../../../../redux/slice/permissionSlide";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";

const css = classNames.bind(styles);

const AddRole = (props: any): JSX.Element => {
  const [form] = Form.useForm();

  const permissions = useAppSelector((state) => state.permission.result);
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const [checkbox, setCheckbox] = useState<any[]>([]);
  const [switchValues, setSwitchValues] = useState<boolean>(true);
  const [loading, setLoading] = useState(false);

  const filterUsers = permissions.filter((item) => item.module === "USERS");
  const filterPosts = permissions.filter((item) => item.module === "POSTS");
  const filterCategories = permissions.filter(
    (item) => item.module === "CATEGORY"
  );
  const filterTopics = permissions.filter((item) => item.module === "TOPIC");
  const filterComments = permissions.filter(
    (item) => item.module === "COMMENTS"
  );
  const filterRoles = permissions.filter((item) => item.module === "ROLES");
  const filterPermissions = permissions.filter(
    (item) => item.module === "PERMISSIONS"
  );
  const filterEmailFollow = permissions.filter(
    (item) => item.module === "EMAIL FOLLOW"
  );
  const filterDashboard = permissions.filter(
    (item) => item.module === "DASHBOARD"
  );

  const filterPodcast = permissions.filter((item) => item.module === "PODCAST");
  const filterUpload = permissions.filter((item) => item.module === "UPLOAD");

  const showModal = () => {
    setOpen(true);
  };
  const onChangeSwitch = (checked: boolean) => {
    setSwitchValues(checked);
  };

  const resetForm = () => {
    form.resetFields();
    setCheckbox([]);
  };

  const onFinish = async (values: any) => {
    setLoading(true);
    const createRole = {
      ...values,
      isActive: switchValues,
      permissions: [...checkbox],
    };
    const res: any = await callCreateRole(createRole);
    if (res && res.statusCode === 201) {
      props.handleFetchRole();
      message.success("update success!");
      resetForm();
      setOpen(false);
    } else {
      notification.error({
        message: "Đã có lỗi xảy ra",
        description: res.message,
      });
    }

    setLoading(false);
  };

  const onChangeCollapse = (key: any) => {};
  const onClose = () => {
    setOpen(false);
  };

  const onChangeGroup = (checkedValues: CheckboxValueType[]) => {
    setCheckbox(checkedValues);
  };

  let query = "current=1&pageSize=150";
  const handleFetchPermission = () => {
    dispatch(fetchPermission({ query }));
  };
  useEffect(() => {
    handleFetchPermission();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Spin spinning={loading}>
      <Button type="primary" onClick={showModal} icon={<PlusOutlined />}>
        Thêm mới
      </Button>
      <Modal
        title="Thêm chức vụ"
        open={open}
        onOk={() => {
          form.submit();
        }}
        okText="Tạo mới"
        cancelText="Hủy"
        maskClosable={false}
        width={840}
        onCancel={onClose}>
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: "Please enter user name" }]}>
                <Input placeholder="Please enter user name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="isActive"
                label="Trạng thái"
                // rules={[{ required: true, message: "Please enter Active" }]}
                style={{ display: "flex", justifyContent: "center" }}>
                <Switch
                  checkedChildren="Active"
                  unCheckedChildren="No"
                  defaultChecked
                  onChange={onChangeSwitch}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="description"
                label="Description"
                rules={[
                  {
                    required: true,
                    message: "please enter role",
                  },
                ]}>
                <Input.TextArea rows={4} placeholder="Miêu tả role" />
              </Form.Item>
            </Col>
          </Row>
          <Checkbox.Group
            style={{ width: "100%" }}
            value={checkbox}
            onChange={onChangeGroup}>
            <Row gutter={16}>
              <Col span={24}>
                <Collapse
                  className={css("container-collapse")}
                  defaultActiveKey={[]}
                  onChange={onChangeCollapse}>
                  <Collapse.Panel header="USERS" key="1">
                    <Row gutter={[16, 16]}>
                      {filterUsers &&
                        filterUsers.length > 0 &&
                        filterUsers.map((item, index) => {
                          return (
                            <Col span={8} key={index}>
                              <Checkbox
                                className={css("checkbox-permission")}
                                value={item._id}>
                                <div className={css("content-checkbox")}>
                                  <b>{item.name}</b>
                                  <div>
                                    <span className={css(`${item.method}`)}>
                                      {item.method}
                                    </span>
                                    <span>{item.apiPath}</span>
                                  </div>
                                </div>
                              </Checkbox>
                            </Col>
                          );
                        })}
                    </Row>
                  </Collapse.Panel>
                  <Collapse.Panel header="POSTS" key="2">
                    <Row gutter={[16, 16]}>
                      {filterPosts &&
                        filterPosts.length > 0 &&
                        filterPosts.map((item, index) => {
                          return (
                            <Col span={8} key={index}>
                              <Checkbox
                                className={css("checkbox-permission")}
                                value={item._id}>
                                <div className={css("content-checkbox")}>
                                  <b>{item.name}</b>
                                  <div>
                                    <span className={css(`${item.method}`)}>
                                      {item.method}
                                    </span>
                                    <span>{item.apiPath}</span>
                                  </div>
                                </div>
                              </Checkbox>
                            </Col>
                          );
                        })}
                    </Row>
                  </Collapse.Panel>
                  <Collapse.Panel header="CATEGORIES" key="3">
                    <Row gutter={[16, 16]}>
                      {filterCategories &&
                        filterCategories.length > 0 &&
                        filterCategories.map((item, index) => {
                          return (
                            <Col span={8} key={index}>
                              <Checkbox
                                className={css("checkbox-permission")}
                                value={item._id}>
                                <div className={css("content-checkbox")}>
                                  <b>{item.name}</b>
                                  <div>
                                    <span className={css(`${item.method}`)}>
                                      {item.method}
                                    </span>
                                    <span>{item.apiPath}</span>
                                  </div>
                                </div>
                              </Checkbox>
                            </Col>
                          );
                        })}
                    </Row>
                  </Collapse.Panel>
                  <Collapse.Panel header="TOPICS" key="4">
                    <Row gutter={[16, 16]}>
                      {filterTopics &&
                        filterTopics.length > 0 &&
                        filterTopics.map((item, index) => {
                          return (
                            <Col span={8} key={index}>
                              <Checkbox
                                className={css("checkbox-permission")}
                                value={item._id}>
                                <div className={css("content-checkbox")}>
                                  <b>{item.name}</b>
                                  <div>
                                    <span className={css(`${item.method}`)}>
                                      {item.method}
                                    </span>
                                    <span>{item.apiPath}</span>
                                  </div>
                                </div>
                              </Checkbox>
                            </Col>
                          );
                        })}
                    </Row>
                  </Collapse.Panel>
                  <Collapse.Panel header="PERMISSIONS" key="5">
                    <Row gutter={[16, 16]}>
                      {filterPermissions &&
                        filterPermissions.length > 0 &&
                        filterPermissions.map((item, index) => {
                          return (
                            <Col span={8} key={index}>
                              <Checkbox
                                className={css("checkbox-permission")}
                                value={item._id}>
                                <div className={css("content-checkbox")}>
                                  <b>{item.name}</b>
                                  <div>
                                    <span className={css(`${item.method}`)}>
                                      {item.method}
                                    </span>
                                    <span>{item.apiPath}</span>
                                  </div>
                                </div>
                              </Checkbox>
                            </Col>
                          );
                        })}
                    </Row>
                  </Collapse.Panel>
                  <Collapse.Panel header="ROLES" key="6">
                    <Row gutter={[16, 16]}>
                      {filterRoles &&
                        filterRoles.length > 0 &&
                        filterRoles.map((item, index) => {
                          return (
                            <Col span={8} key={index}>
                              <Checkbox
                                className={css("checkbox-permission")}
                                value={item._id}>
                                <div className={css("content-checkbox")}>
                                  <b>{item.name}</b>
                                  <div>
                                    <span className={css(`${item.method}`)}>
                                      {item.method}
                                    </span>
                                    <span>{item.apiPath}</span>
                                  </div>
                                </div>
                              </Checkbox>
                            </Col>
                          );
                        })}
                    </Row>
                  </Collapse.Panel>
                  <Collapse.Panel header="COMMENTS" key="7">
                    <Row gutter={[16, 16]}>
                      {filterComments &&
                        filterComments.length > 0 &&
                        filterComments.map((item, index) => {
                          return (
                            <Col span={8} key={index}>
                              <Checkbox
                                className={css("checkbox-permission")}
                                value={item._id}>
                                <div className={css("content-checkbox")}>
                                  <b>{item.name}</b>
                                  <div>
                                    <span className={css(`${item.method}`)}>
                                      {item.method}
                                    </span>
                                    <span>{item.apiPath}</span>
                                  </div>
                                </div>
                              </Checkbox>
                            </Col>
                          );
                        })}
                    </Row>
                  </Collapse.Panel>
                  <Collapse.Panel header="DASHBOARD" key="8">
                    <Row gutter={[16, 16]}>
                      {filterDashboard &&
                        filterDashboard.length > 0 &&
                        filterDashboard.map((item, index) => {
                          return (
                            <Col span={8} key={index}>
                              <Checkbox
                                className={css("checkbox-permission")}
                                value={item._id}>
                                <div className={css("content-checkbox")}>
                                  <b>{item.name}</b>
                                  <div>
                                    <span className={css(`${item.method}`)}>
                                      {item.method}
                                    </span>
                                    <span>{item.apiPath}</span>
                                  </div>
                                </div>
                              </Checkbox>
                            </Col>
                          );
                        })}
                    </Row>
                  </Collapse.Panel>
                  <Collapse.Panel header="EMAIL FOLLOW" key="9">
                    <Row gutter={[16, 16]}>
                      {filterEmailFollow &&
                        filterEmailFollow.length > 0 &&
                        filterEmailFollow.map((item, index) => {
                          return (
                            <Col span={8} key={index}>
                              <Checkbox
                                className={css("checkbox-permission")}
                                value={item._id}>
                                <div className={css("content-checkbox")}>
                                  <b>{item.name}</b>
                                  <div>
                                    <span className={css(`${item.method}`)}>
                                      {item.method}
                                    </span>
                                    <span>{item.apiPath}</span>
                                  </div>
                                </div>
                              </Checkbox>
                            </Col>
                          );
                        })}
                    </Row>
                  </Collapse.Panel>
                  <Collapse.Panel header="PODCAST" key="10">
                    <Row gutter={[16, 16]}>
                      {filterPodcast &&
                        filterPodcast.length > 0 &&
                        filterPodcast.map((item, index) => {
                          return (
                            <Col span={8} key={index}>
                              <Checkbox
                                className={css("checkbox-permission")}
                                value={item._id}>
                                <div className={css("content-checkbox")}>
                                  <b>{item.name}</b>
                                  <div>
                                    <span className={css(`${item.method}`)}>
                                      {item.method}
                                    </span>
                                    <span>{item.apiPath}</span>
                                  </div>
                                </div>
                              </Checkbox>
                            </Col>
                          );
                        })}
                    </Row>
                  </Collapse.Panel>
                  <Collapse.Panel header="UPLOAD" key="11">
                    <Row gutter={[16, 16]}>
                      {filterUpload &&
                        filterUpload.length > 0 &&
                        filterUpload.map((item, index) => {
                          return (
                            <Col span={8} key={index}>
                              <Checkbox
                                className={css("checkbox-permission")}
                                value={item._id}>
                                <div className={css("content-checkbox")}>
                                  <b>{item.name}</b>
                                  <div>
                                    <span className={css(`${item.method}`)}>
                                      {item.method}
                                    </span>
                                    <span>{item.apiPath}</span>
                                  </div>
                                </div>
                              </Checkbox>
                            </Col>
                          );
                        })}
                    </Row>
                  </Collapse.Panel>
                </Collapse>
              </Col>
            </Row>
          </Checkbox.Group>
        </Form>
      </Modal>
    </Spin>
  );
};

export default AddRole;
